import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { DecksPage } from '../features/decks/page'
import { DeckPage } from '../features/decks/deck-page'
import { parseDecksSearch } from '../features/decks/list-search'

export const decksRoute = createRoute({
  path: 'decks',
  getParentRoute: () => rootRoute,
  validateSearch: parseDecksSearch,
  component: function DecksRoute() {
    return <DecksPage search={decksRoute.useSearch()} creating={false} />
  },
})

export const deckNewRoute = createRoute({
  path: 'decks/new',
  getParentRoute: () => rootRoute,
  validateSearch: parseDecksSearch,
  component: function DeckNewRoute() {
    return <DecksPage search={deckNewRoute.useSearch()} creating />
  },
})

export const deckRoute = createRoute({
  path: 'decks/$deckId',
  getParentRoute: () => rootRoute,
  component: function DeckRoute() {
    const { deckId } = deckRoute.useParams()
    return <DeckPage key={deckId} deckId={deckId} />
  },
})
